import React, { Fragment} from 'react'
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../errorBoundary';

const CommonRoute = () => {
    return (
        <ErrorBoundary>
            <div className="flex text-gray-700 text-sm overflow-x-hidden">
                <Fragment>
                    <div className={"w-full h-screen overflow-y-auto p-4"}>
                        <Outlet />
                    </div>
                </Fragment>
            </div>
        </ErrorBoundary>
    )
}

export default CommonRoute;
